import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import CircularProgress from '@mui/material/CircularProgress'
import { alpha } from '@mui/material/styles'
import { format, subHours } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { memo } from 'react'

/**
 * Функция для форматирования времени с коррекцией -5 часов
 * @param {string} dateTimeString - строка с датой и временем
 * @returns {string} - отформатированная строка с коррекцией
 */
const formatTimeWith5HourAdjustment = (dateTimeString) => {
  const originalDate = new Date(dateTimeString)
  const adjustedDate = subHours(originalDate, 5)
  return format(adjustedDate, 'dd.MM.yyyy HH:mm')
}

const UrvTableContentView = ({ data, isLoading }) => {
  const { t } = useTranslation()
  return (
    <TableContainer
      component={Paper}
      sx={(theme) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.common.white, 0.02)
            : theme.palette.background.paper
      })}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <b>IIN</b>
            </TableCell>
            <TableCell>
              <b>{t('name')}</b>
            </TableCell>
            <TableCell>
              <b>{t('time')}</b>
            </TableCell>
            <TableCell>
              <b>{t('direction')}</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <CircularProgress size={24} />
              </TableCell>
            </TableRow>
          ) : (
            (data?.data || []).map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.iin}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>
                  {formatTimeWith5HourAdjustment(row.entrance_time)}
                </TableCell>
                <TableCell>
                  {row.direction === 'in' ? t('entrance') : t('output')}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const UrvTableContent = memo(UrvTableContentView)

export default UrvTableContent
